import containerQueries from '@tailwindcss/container-queries';
import { pick } from 'lodash';
import defaultTheme from 'tailwindcss/defaultTheme';

export default {
  content: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}', '../*/src/**/*.{vue,js,ts,jsx,tsx}'],
  theme: {
    extend: {
      zIndex: {
        subfooter: '120',
        footer: '130',
        dropdown: '135',
        sidebar: '139',
        header: '140',
        'subfooter-nav-bar': '141',
        modal: '150',
        notification: '151',
      },
      transitionProperty: {
        text: 'font-size, line-height',
      },
    },
    screens: {
      xs: '475px',
      ...pick(defaultTheme.screens, ['sm', 'md', 'lg', 'xl', '2xl']),
      '3xl': '1792px',
    },
  },
  plugins: [containerQueries],
};
